<template>
  <project-layout :projectName="this.$options.name">
    <p>The Granton's design concept is done by One Fell Swoop, and I was participated in website's design. The goal was to keep the same visual language, but also translate it into interactive inteface design.</p>
      <img :src="imagePath + 'works-granton-01.jpg'" :alt="this.$options.name" class="shadow" />
      <img :src="imagePath + 'works-granton-02.jpg'" :alt="this.$options.name" class="shadow" />
      <img :src="imagePath + 'works-granton-03.jpg'" :alt="this.$options.name" class="shadow" />
      <img :src="imagePath + 'works-granton-04.jpg'" :alt="this.$options.name" class="shadow" />
      <img :src="imagePath + 'works-granton-05.jpg'" :alt="this.$options.name" class="shadow" />
      <img :src="imagePath + 'works-granton-06.jpg'" :alt="this.$options.name" class="shadow" />
      <img :src="imagePath + 'works-granton-07.png'" :alt="this.$options.name" class="shadow" />
      <div class="cols col-3">
        <img :src="imagePath + 'works-granton-m-01.jpg'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-m-02.jpg'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-m-03.jpg'" :alt="this.$options.name" class="border" />
      </div>
      <p>The layout designs are based on number of modules, so it's easy to maintain and scale.</p>
      <div class="cols col-2-row-4">
        <img :src="imagePath + 'works-granton-module-01.png'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-module-02.png'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-module-03.png'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-module-04.png'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-module-05.png'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-module-06.png'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-module-07.png'" :alt="this.$options.name" class="border" />
        <img :src="imagePath + 'works-granton-module-08.png'" :alt="this.$options.name" class="border" />
      </div>
  </project-layout>  
</template>

<script>
  import ProjectLayout from '@/layouts/ProjectLayout.vue'
  import DataPath from '@/components/DataPath.vue'

  export default {
    name: 'granton',
    components: {
      'project-layout': ProjectLayout
    },
    data () {
      return {
        imagePath: '',
        videoPath: ''
      }
    },
    created () {
      this.imagePath = DataPath.data().imagePath + this.$options.name + '/'
      this.videoPath = DataPath.data().videoPath + this.$options.name + '/'
    }
  }
</script>

<style lang="sass" scoped>
</style>


// WEBPACK FOOTER //
// src/contents/Granton.vue